import React from "react";
import { Button, Grid, Modal, Typography } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import correct from "../../images/correct.svg";
import incorrect from "../../images/incorrect.svg";
import adjust from "../../images/adjust.svg";
// import equation from "../../images/equation.svg";
// import equationQ1 from "../../images/equationQ1.svg";

import styles from "./styles";
import "animate.css/animate.css";

const EvaluatorModal = ({
  classes,
  nextQuestion,
  answeredCorrectly,
  question,
}) => {
  let newPrice =
    parseFloat(question.old.price.replace(",", "")) *
    (question.new.cpi / question.old.cpi);
  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh" }}
      >
        <Grid className={`${classes.evaluatorModalContainer}`}>
          <Grid container justify="center">
            {answeredCorrectly ? (
              <img
                alt=""
                src={correct}
                className={classes.correctIncorrectIcon}
              />
            ) : (
              <img
                alt=""
                src={incorrect}
                className={classes.correctIncorrectIcon}
              />
            )}
          </Grid>
          <Grid container className={classes.comparisonContainer}>
            <Grid container className={classes.comparisonFirstHalf}>
              <Grid item>
                <Typography className={classes.yearPrice}>
                  {question.old.year}
                </Typography>
                <Typography className={classes.yearPrice}>
                  ${question.old.price}
                </Typography>
              </Grid>

              <Grid item className={classes.adjustImage}>
                <img src={adjust} alt={""} />
              </Grid>

              <Grid
                item
                className={question.answer === 1 && classes.newPriceBox}
              >
                <Typography className={classes.yearPrice}>
                  {question.inflation.year}
                </Typography>
                <Typography
                  className={classes.yearPrice}
                  style={{ fontWeight: "bold" }}
                >
                  ${question.inflation.price}
                </Typography>
                {question.answer === 1 && (
                  <Typography
                    className={classes.cheaperText}
                    style={{ margin: 0 }}
                  >
                    (Cheaper!)
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid item className={classes.whiteSpace}></Grid>
            <Grid container className={classes.comparisonSecondHalf}>
              <Typography
                className={`${classes.yearPrice} ${
                  question.answer === 2 && classes.newPriceBox
                }`}
              >
                {question.new.year}
              </Typography>
              <Typography
                className={classes.yearPrice}
                style={{ fontWeight: "bold" }}
              >
                ${question.new.price}
              </Typography>
              {question.answer === 2 && (
                <Typography className={classes.cheaperText}>
                  (Cheaper!)
                </Typography>
              )}
            </Grid>
          </Grid>

          <Typography
            className={classes.evalDesc}
            style={{ textAlign: "center" }}
          >
            To adjust dollars between time periods for inflation we use the
            formula:
          </Typography>

          <Grid container justifyContent="center">
            <img src={question.equation} alt={""} className={classes.equationImg} />
          </Grid>

          <Typography
            className={classes.evalDesc}
            dangerouslySetInnerHTML={{ __html: question.detailText }}
          >
            {/* {question.detailText} */}
          </Typography>
          <Grid container justify="center">
            <Button
              className={classes.submitButton}
              onClick={() => nextQuestion()}
            >
              NEXT
            </Button>
          </Grid>
          <Grid
            container
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            <Typography
              className={classes.bottomDescription}
              dangerouslySetInnerHTML={{ __html: question.sourcesText }}
            >
              {/* {question.sourcesText} */}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default withStyles(styles)(EvaluatorModal);
